// Languages key and human name
export const Languages = {
  catalan: "Catalan",
  german: "German",
  english: "English",
  latin: "Latin",
  other: "Other",
  spanish: "Spanish",
};

export type Language = keyof typeof Languages;

export const LanguageKeys = Object.keys(Languages) as Language[];

export const ChoirIds = {
  catalog: 558,
  community: 759,
};

// Piece statuses: constant name to use in the code and string used in database
export const enum PieceStatuses {
  Queued = "queued",
  Processing = "processing",
  Error = "error",
  Draft = "draft",
  Published = "published",
}

export const PendingPieceStatuses = [PieceStatuses.Queued, PieceStatuses.Processing];
export const FinalPieceStatuses = [PieceStatuses.Error, PieceStatuses.Draft, PieceStatuses.Published];
export const CorrectPieceStatuses = [PieceStatuses.Draft, PieceStatuses.Published];
export const VersionablePieceStatuses = [PieceStatuses.Error, PieceStatuses.Draft, PieceStatuses.Published];

export const ScoreExtensions = ["musicxml", "mxl", "xml"] as const;
export type ScoreExtension = typeof ScoreExtensions[number];
